export const REWARD_FLAG = {
	OFFER: 0,
	SIGNUP: 1,
	VISITS: 2,
	COMPS: 3,
	CUST_CREDIT: 4,
	BUSINESS_DISCOUNT: 5,
	FEEDBACK: 6,
	APP_INSTALL: 7,
} as const;
export type TRewardFlag = typeof REWARD_FLAG[keyof typeof REWARD_FLAG];
